const routes = [
    {
        path: "",
        meta: {
            layout: "PublicLayout",
        },
        children: [
            {
                name: "signin",
                path: "/signin",
                component: () => import("@/views/SignIn.vue"),
            },
            {
                name: "signup",
                path: "/signup",
                component: () => import("@/views/SignUp.vue"),
            },
            {
                name: "forgot-password",
                path: "/forgot-password",
                component: () => import("@/views/ForgotPassword.vue"),
            },
            {
                name: "change-password",
                path: "/change-password",
                component: () => import("@/views/ChangePassword.vue"),
            },
            {
                name: "verify-member",
                path: "/verify-member",
                component: () => import("@/views/VerifyMember.vue"),
            },
            {
                name: "verify-account",
                path: "/verify-account",
                component: () => import("@/views/VerifyAccount.vue"),
            },
            {
                name: "signout",
                path: "/signout",
                component: () => import("@/views/SignOut.vue"),
            },

            {
                name: "servererror",
                path: "/servererror",
                component: () => import("@/views/ServerError.vue"),
            },
            {
                name: "signedout",
                path: "/signedout",
                component: () => import("@/views/SignedOut.vue"),
            },
            {
                name: "maintenance",
                path: "/maintenance",
                component: () => import("@/views/Maintenance.vue"),
            },
            {
                name: "no-access",
                path: "/no-access",
                component: () => import("@/views/NoAccess.vue"),
            },

            // {
            //     path: "/resetpassword",
            //     component: () => import("@/views/ResetPassword.vue"),
            // },
            // {
            //     path: "/createpassword",
            //     component: () => import("@/views/CreatePassword.vue"),
            // },
            // {
            //     path: "/mfa/challenge",
            //     component: () => import("@/views/MFAChallenge.vue"),
            // },
        ],
    },

    {
        meta: {
            layout: "AuthenticatedMinimalLayout",
            authenticated: true,
        },
        children: [
            // {
            //     path: "/devices/:id/video/stream",
            //     component: () =>
            //         import("@/views/authenticated/VideoStream.vue"),
            // },
            {
                name: "fullscreen-camera",
                path: "/fullscreen-camera-view/:id",
                component: () => import("@/views/FullScreenCamera.vue"),
                props: true, // Pass route params as props to the component
            },
        ],
    },

    // App-level routes (top-level domain)
    {
        meta: {
            layout: "AppLayout",
            authenticated: true,
            appLevel: true,
        },
        children: [
            {
                name: "app-dashboard",
                path: "/",
                component: () => import("@/views/app/Communities.vue"),
                meta: {
                    label: "Communities",
                    icon: "far fa-building",
                },
            },
            {
                name: "welcome",
                path: "/welcome",
                component: () => import("@/views/app/Welcome.vue"),
                meta: {
                    allowAllRoles: true,
                },
            },
            {
                name: "users",
                path: "/users",
                component: () => import("@/views/app/Users.vue"),
                meta: {
                    label: "Users",
                    icon: "fasl fa-users",
                },
            },
        ],
    },

    // Community settings routes (nested under CommunitySettingsLayout)
    {
        path: "/communities/:id",
        component: () => import("@/layouts/CommunitySettingsLayout.vue"),
        meta: {
            layout: "AppLayout",
            authenticated: true,
            appLevel: true,
        },
        children: [
            {
                name: "community-members",
                path: "members",
                component: () => import("@/views/app/CommunityMembers.vue"),
                meta: {
                    label: "Members",
                    icon: "far fa-users",
                },
            },
            {
                name: "community-venues",
                path: "venues",
                component: () => import("@/views/app/CommunityVenues.vue"),
                meta: {
                    label: "Venues",
                    icon: "far fa-map-marker-alt",
                },
            },
            {
                name: "community-groups",
                path: "groups",
                component: () => import("@/views/app/CommunityGroups.vue"),
                meta: {
                    label: "Groups",
                    icon: "far fa-layer-group",
                },
            },
            {
                name: "community-skyward",
                path: "skyward",
                component: () => import("@/views/app/CommunitySkyward.vue"),
                meta: {
                    label: "Skyward",
                    icon: "far fa-school",
                },
            },
            {
                name: "community-policy",
                path: "policy",
                component: () => import("@/views/app/CommunityPolicy.vue"),
                meta: {
                    label: "Policy",
                    icon: "far fa-shield-check",
                },
            },
            {
                name: "community-group-detail",
                path: "groups/:groupId",
                component: () =>
                    import("@/views/app/CommunityGroupDetail.vue"),
                meta: {
                    label: "Group Detail",
                    icon: "far fa-layer-group",
                },
            },
            {
                // Redirect /communities/:id to members tab by default
                path: "",
                redirect: (to) => `/communities/${to.params.id}/members`,
            },
        ],
    },

    // Community-level routes (community subdomains)
    // Legacy/redirect routes - handled via router guard redirect logic
    {
        meta: {
            layout: "AuthenticatedLayout",
            authenticated: true,
            communityLevel: true,
        },
        children: [
            {
                name: "legacy-home",
                path: "/",
                meta: { redirectToMode: "operator" },
                // Redirect handled in router guard
                component: { template: "<div />" },
            },
            {
                name: "operator-home-redirect",
                path: "/__redirect/operator",
                meta: { redirectToMode: "operator" },
                component: { template: "<div />" },
            },
            {
                name: "legacy-installer",
                path: "/installer",
                meta: { redirectToMode: "installer" },
                component: { template: "<div />" },
            },
            {
                name: "installer-home-redirect",
                path: "/__redirect/installer",
                meta: { redirectToMode: "installer" },
                component: { template: "<div />" },
            },
        ],
    },

    // Installer mode routes (Admin only)
    {
        meta: {
            layout: "AuthenticatedLayout",
            authenticated: true,
            communityLevel: true,
            mode: "installer",
            requiresAdmin: true,
        },
        children: [
            {
                name: "installer-home",
                path: "/i/v/:venueId",
                component: () =>
                    import("@/views/authenticated/InstallerMapLayout.vue"),
                meta: {
                    label: "Beacon Installation",
                    icon: "far fa-location-dot",
                    mapView: true,
                },
                props: (route) => ({
                    venueId: Number(route.params.venueId),
                }),
            },
            {
                name: "installer-devices",
                path: "/i/v/:venueId/devices",
                component: () =>
                    import("@/views/authenticated/DeviceList.vue"),
                meta: {
                    label: "Devices",
                    icon: "far fa-microchip",
                },
                props: (route) => ({
                    venueId: Number(route.params.venueId),
                }),
            },
        ],
    },

    // Operator mode routes
    {
        meta: {
            layout: "AuthenticatedLayout",
            authenticated: true,
            communityLevel: true,
            mode: "operator",
        },
        children: [
            {
                name: "operator-home",
                path: "/o/v/:venueId",
                component: () => import("@/views/authenticated/MapLayout.vue"),
                meta: {
                    label: "Venue",
                    icon: "far fa-map",
                    navigationHover: true,
                    mapView: true,
                },
                props: (route) => ({
                    venueId: Number(route.params.venueId),
                }),
            },
            {
                path: "/o/v/:venueId/i/:incidentId",
                name: "operator-incident-dashboard",
                meta: { navigationHover: true, mapView: true },
                component: () => import("@/views/authenticated/MapLayout.vue"),
                props: (route) => ({
                    venueId: Number(route.params.venueId),
                    incidentId: Number(route.params.incidentId),
                }),
            },

            {
                path: "/o/v/:venueId/incidents",
                name: "operator-incidents",
                component: () =>
                    import("@/views/authenticated/IncidentList.vue"),
                meta: {
                    label: "Incidents",
                    icon: "fasl fa-indent",
                },
                props: (route) => ({
                    venueId: Number(route.params.venueId),
                }),
            },

            {
                path: "/o/v/:venueId/notifications",
                name: "operator-notifications",
                component: () =>
                    import("@/views/authenticated/NotificationMessageList.vue"),
                meta: {
                    label: "Notifications",
                    icon: "fasl fa-bell",
                },
                props: (route) => ({
                    venueId: Number(route.params.venueId),
                }),
            },

            {
                path: "/o/v/:venueId/notifications/templates",
                name: "operator-notification-templates",
                component: () =>
                    import(
                        "@/views/authenticated/NotificationTemplateList.vue"
                    ),
                meta: {
                    label: "Notification Templates",
                    icon: "far fa-file-lines",
                },
                props: (route) => ({
                    venueId: Number(route.params.venueId),
                }),
            },

            {
                path: "/o/v/:venueId/devices",
                name: "operator-devices",
                component: () => import("@/views/authenticated/DeviceList.vue"),
                meta: {
                    label: "Devices",
                    icon: "fasl fa-router",
                },
                props: (route) => ({
                    venueId: Number(route.params.venueId),
                }),
            },

            {
                path: "/o/v/:venueId/safezones",
                name: "operator-safezones",
                component: () =>
                    import("@/views/authenticated/SafezoneList.vue"),
                meta: {
                    label: "Safe Zones",
                    icon: "fasl fa-person-shelter",
                },
                props: (route) => ({
                    venueId: Number(route.params.venueId),
                }),
            },

            {
                path: "/o/v/:venueId/endusers",
                name: "operator-endusers",
                component: () =>
                    import("@/views/authenticated/EndUserList.vue"),
                meta: {
                    label: "End Users",
                    icon: "fasl fa-users",
                },
                props: (route) => ({
                    venueId: Number(route.params.venueId),
                }),
            },
            {
                path: "/o/v/:venueId/endusers/:id",
                name: "operator-enduser-details",
                component: () =>
                    import("@/views/authenticated/EndUserDetails.vue"),
                props: (route) => ({
                    venueId: Number(route.params.venueId),
                    endUserId: Number(route.params.id),
                }),
            },

            {
                path: "/o/v/:venueId/wearables",
                name: "operator-wearables",
                component: () =>
                    import("@/views/authenticated/WearableList.vue"),
                meta: {
                    label: "Wearables",
                    icon: "fasl fa-id-badge",
                },
                props: (route) => ({
                    venueId: Number(route.params.venueId),
                }),
            },

            // {
            //     path: "/o/v/:venueId/settings",
            //     component: () =>
            //         import("@/views/authenticated/OrganizationEdit.vue"),
            //     meta: {
            //         label: "Settings",
            //         icon: "fasl fa-gears",
            //     },
            // },
        ],
    },

    {
        meta: {
            layout: "AuthenticatedLayout",
            authenticated: true,
        },
        children: [
            // {
            //     path: "/tests/cameratest",
            //     // meta: {
            //     //     icon: "fasl fa-flask-vial",
            //     //     label: "Test",
            //     // },
            //     component: () => import("@/views/tests/CameraTestView.vue"),
            // },
            {
                path: "/tests/mqtt-stream",
                name: "mqtt-stream-test",
                meta: {
                    label: "MQTT Stream Test",
                    icon: "fas fa-broadcast-tower",
                },
                component: () => import("@/views/tests/MqttStreamTestView.vue"),
            },
        ],
    },

    {
        path: "/:catchAll(.*)*",
        component: () => import("@/views/404.vue"),
    },
];

export default routes;
